module.exports = __webpack_public_path__ + "img/stage2.433e3055.png";